/*eslint-disable*/

import './searchResult.css';

import BannerCarousel from '../../components/bannerCarousel/BannerCarousel';
import TripCard from '../../components/tripCard/TripCard';
import Filters from '../../components/filters/Filters';
import filterDummy from '../../dummyData/typeOfFilters.json';
import ReactLoading from 'react-loading';

import { useEffect, useMemo, useRef, useState } from 'react';

import { fetchSearchResult } from './searchResultFun/fetchSearchResult';
import { banners } from '../../dummyData/searchResults';

import { debounce } from '../../utils/debounce.js';

import { handleFilterChange } from './searchResultFun/filterChange.js';

import MobileFilter from './mobileFilter.jsx';

import { useLocation, useParams, useSearchParams, useNavigate } from 'react-router-dom';

import EmptyPage from '../../components/empty-page/emptyPage.jsx';

import { convertSearchQueryParamsToPlainObj, createSearchQueryParams } from '../../utils/handleQueryParams.js';

import FilterHeader from '../../components/FilterHeaderInSearchResult/FilterHeader.jsx';

import { fetchDataBaseOnLocation } from './searchResultFun/fetchFilters.js';
import { trackEvent } from '../../utils/analytics.js';
import { getFilterDetailsFun } from '../../api/infoAPI';
import CampFilters from '../../components/campFilters/CampFilters.jsx';
import CampSearchHero from '../../components/campSearchHero/CampSearchHero.jsx';
import CampSearchResults, { CampSearchToolbar } from '../../components/campSearchHero/CampSearchResults.jsx';

// Camp sidebar filters saved in the URL (?unitTypes=tent,cottage&minPrice=2000 ...)
const CAMP_FILTER_KEYS = ['minPrice', 'maxPrice', 'unitTypes', 'propertyTypes', 'amenities'];
const toNum = (v) => (v === undefined || v === '' || Number.isNaN(Number(v)) ? null : Number(v));

export default function SerachResult() {
    const debounceTimeout = useRef(null);
    const searchResultRef = useRef(null);
    const filterButtonRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchData, setSearchData] = useState([]);

    const [sortData, setSortData] = useState({
        sortBy: ''
    });

    const [offset, setOffset] = useState(0);

    const [showModal, setShowModal] = useState(false);

    const [hasMore, setHasMore] = useState(true);

    const [isSticked, setIsSticked] = useState(false);

    const [selectedChipFilter, setSelectedChipFilter] = useState('All');

    const [selectedSort, setSelectedSort] = useState('relevant');

    const [locationData, setLocationData] = useState([]);

    // Camp: sidebar options + total + banner image (from the first page of results)
    const [campMeta, setCampMeta] = useState(null);

    // Camp: sidebar filters added by support (same for every search, loaded once)
    const [campSections, setCampSections] = useState(null);

    const { type, text } = useParams();

    const [searchParams, setSearchParams] = useSearchParams();

    const location = useLocation();
    const navigate = useNavigate();

    const { limit } = location.state || {};

    const [localLimit, setLocalLimit] = useState(limit || 9);

    /*
     * IMPORTANT
     *
     * `text` is the destination from the URL.
     *
     * Example:
     * /search-result/trip/Bengaluru
     *
     * text = "Bengaluru"
     */
    const destination = decodeURIComponent(text || '');
    const destType = searchParams.get('type') || '';
    const place = searchParams.get('place') || '';
    const activity = searchParams.get('activity') || '';
    const lastTrackedSearch = useRef('');
    const isCamp = type === 'camp';

    /*
     * Fetch location filters
     */
    useEffect(() => {
        fetchDataBaseOnLocation(type, setLocationData);
    }, [type]);

    /*
     * Camp sidebar sections (Support → Dropdowns/Filters → Filter, type Camp).
     * `field` = what each one filters on: unitTypes / propertyTypes / amenities.
     */
    useEffect(() => {
        if (type !== 'camp' || campSections) return;
        getFilterDetailsFun('camp')
            .then((res) => {
                const list = Array.isArray(res?.data) ? res.data : [];
                setCampSections(
                    list
                        .filter((f) => f.field && f.dropdown?.length)
                        .map((f) => ({
                            _id: f._id,
                            heading: f.heading,
                            field: f.field,
                            options: f.dropdown.map((o) => ({ value: o.name, label: o.displayName || o.name }))
                        }))
                );
            })
            .catch(() => setCampSections([]));
    }, [type, campSections]);

    const sortOptions = [
        {
            label: 'Relevant',
            value: 'relevant'
        },
        {
            label: 'Price: Low to High',
            value: 'low'
        },
        {
            label: 'Price: High to Low',
            value: 'high'
        }
    ];

    /*
     * Mobile sticky filter
     */
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth >= 768 || !filterButtonRef.current) {
                setIsSticked(false);
                return;
            }

            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }

            debounceTimeout.current = setTimeout(() => {
                const scrollTop = window.scrollY;
                const triggerPoint = 230;

                setIsSticked(scrollTop > triggerPoint);
            }, 0);
        };

        window.addEventListener('scroll', handleScroll);

        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);

            window.removeEventListener('resize', handleScroll);

            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, []);

    /*
     * Convert URL filters
     */
    const filters = useMemo(() => convertSearchQueryParamsToPlainObj(searchParams), [searchParams]);

    /*
     * Camp sidebar: current values (from the URL) + save changes in the URL.
     * Other params (place, checkin, guests ...) are kept.
     */
    const campFilterValue = useMemo(
        () => ({
            minPrice: toNum(filters.minPrice?.[0]),
            maxPrice: toNum(filters.maxPrice?.[0]),
            unitTypes: filters.unitTypes || [],
            propertyTypes: filters.propertyTypes || [],
            amenities: filters.amenities || []
        }),
        [filters]
    );

    const handleCampFilterChange = (changes) => {
        const next = new URLSearchParams(searchParams);
        Object.entries(changes).forEach(([key, value]) => {
            if (!CAMP_FILTER_KEYS.includes(key)) return;
            const text = Array.isArray(value) ? value.join(',') : value ?? '';
            if (text === '') next.delete(key);
            else next.set(key, String(text));
        });
        setSearchParams(next, { replace: true });
    };

    useEffect(() => {
        const searchData = {
            type,
            destination: destination || null,
            destType: destType || null,
            place: place || null,
            activity: activity || null,
            filters
        };

        const hasSearchData = destination || destType || place || activity || Object.keys(filters || {}).length > 0;

        if (!hasSearchData) return;

        const searchKey = JSON.stringify(searchData);

        if (lastTrackedSearch.current === searchKey) {
            return;
        }

        lastTrackedSearch.current = searchKey;

        trackEvent({
            event: 'search',

            page: window.location.pathname + window.location.search,

            metadata: searchData
        });
    }, [type, destination, destType, place, activity, filters]);
    /*
     * Selected base city
     */
    useEffect(() => {
        const selectedCities = filters?.base_city || [];

        if (selectedCities.length === 0) {
            setSelectedChipFilter('All');
            return;
        }

        const matchedCity = locationData.find((city) => city.name === selectedCities[0]);

        if (matchedCity) {
            setSelectedChipFilter(matchedCity.name);
        } else {
            setSelectedChipFilter('All');
        }
    }, [filters?.base_city, locationData]);

    /*
     * =========================
     * FETCH SEARCH RESULTS
     * =========================
     */
    useEffect(() => {
        const fetchData = async () => {
            try {
                /*
                 * Clear existing results
                 * when starting a new search.
                 */
                if (offset === 0) {
                    setSearchData([]);
                }

                /*
                 * =========================
                 * ACTIVITY SEARCH
                 * =========================
                 */
                if (type === 'act') {
                    await fetchSearchResult(
                        type,
                        {
                            place,
                            activity
                        },
                        filters,
                        offset,
                        localLimit,
                        sortData.sortBy,
                        setLoading,
                        setSearchData,
                        setHasMore,
                        offset !== 0
                    );

                    return;
                }

                /*
                 * =========================
                 * CAMP SEARCH
                 * =========================
                 *
                 * Camp search uses structured data:
                 *
                 * {
                 *   place,
                 *   checkin,
                 *   checkout,
                 *   adults,
                 *   children,
                 *   pets
                 * }
                 */
                if (type === 'camp') {
                    await fetchSearchResult(
                        type,
                        {
                            place: place || destination || '',

                            checkin: searchParams.get('checkin') || '',

                            checkout: searchParams.get('checkout') || '',

                            adults: Number(searchParams.get('adults')) || 1,

                            children: Number(searchParams.get('children')) || 0,

                            pets: Number(searchParams.get('pets')) || 0
                        },
                        filters,
                        offset,
                        localLimit,
                        sortData.sortBy,
                        setLoading,
                        setSearchData,
                        setHasMore,
                        offset !== 0,
                        // first page: sidebar options, total, banner image
                        (data) => {
                            if (data?.facets) {
                                setCampMeta({
                                    facets: data.facets,
                                    total: data.pagination?.total ?? null,
                                    heroImage: data.heroImage || null
                                });
                            }
                        }
                    );

                    return;
                }

                /*
                 * =========================
                 * TRIP / OTHER SEARCH
                 * =========================
                 *
                 * destination comes from URL text.
                 */
                await fetchSearchResult(
                    type,
                    destination,
                    filters,
                    offset,
                    localLimit,
                    sortData.sortBy,
                    setLoading,
                    setSearchData,
                    setHasMore,
                    offset !== 0
                );
            } catch (err) {
                console.log('Failed to fetch search results', err);
            }
        };

        fetchData();
    }, [type, destination, place, activity, filters, sortData.sortBy, localLimit, offset, searchParams]);

    /*
     * Sort results
     */
    useEffect(() => {
        let updatedData = [...searchData];

        // the price the card shows (same as formatTripData)
        const priceOf = (item) => {
            if (type === 'camp')
                return Number(
                    item?.availability?.unit?.price ??
                        item?.units?.[0]?.pricing?.[0]?.actualPrice ??
                        item?.units?.[0]?.pricing?.[0]?.basePrice ??
                        0
                );
            if (type === 'act') return Number(item?.price?.[0]?.actual) || 0;
            if (type === 'gu') {
                const prices = (item?.price || []).map((p) => Number(p?.perPersonPrice)).filter((n) => n > 0);
                return prices.length ? Math.min(...prices) : 0;
            }
            return Number(item?.price?.[0]?.price?.actual || item?.price?.[0]?.customPrice?.perPerson) || 0;
        };
        if (sortData.sortBy === 'Low to High') {
            updatedData.sort((a, b) => priceOf(a) - priceOf(b));
        } else if (sortData.sortBy === 'High to Low') {
            updatedData.sort((a, b) => priceOf(b) - priceOf(a));
        }

        setFilteredData(updatedData);
    }, [sortData.sortBy, searchData]);

    /*
     * Load more
     */
    const handleLoadMore = () => {
        setOffset((prev) => prev + localLimit);
    };

    /*
     * Mobile filter
     */
    const handleMobileFilter = () => {
        setShowModal(!showModal);
    };

    /*
     * Filter changes
     */
    const debouncedHandleFilter = useMemo(
        () =>
            debounce((selectedFilters) => {
                // replace: filter changes shouldn't add browser history entries
                setSearchParams(createSearchQueryParams(selectedFilters), { replace: true });
            }, 300),
        []
    );

    /*
     * Base city chip
     */
    useEffect(() => {
        // camp has no base-city chips (and this would rewrite its URL)
        if (type === 'camp') return;

        const updatedFilters = {
            ...filters,

            base_city: selectedChipFilter === 'All' ? [] : [selectedChipFilter]
        };

        debouncedHandleFilter(updatedFilters);
    }, [selectedChipFilter]);

    /*
     * Reset pagination when
     * search/filter/sort changes
     */
    useEffect(() => {
        setOffset(0);
    }, [type, destination, filters, sortData.sortBy]);

    /*
     * Cleanup debounce
     */
    useEffect(() => {
        return () => {
            debouncedHandleFilter.cancel?.();
        };
    }, [debouncedHandleFilter]);

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}

            {!isCamp && <BannerCarousel imageData={banners} className='searchResults' />}

            <div ref={searchResultRef} className={`searchReDiv customContainer ${isCamp ? 'campSearchLayout' : ''}`}>
                {isCamp ? (
                    <div className='desktopFilterVersion'>
                        <CampFilters
                            sections={campSections}
                            facets={campMeta?.facets}
                            value={campFilterValue}
                            onChange={handleCampFilterChange}
                        />
                    </div>
                ) : (
                    <Filters
                        className='desktopFilterVersion'
                        filterData={filterDummy?.data}
                        onFilterChange={debouncedHandleFilter}
                        prevFilters={filters}
                        selectedChipFilter={selectedChipFilter}
                        type={type}
                    />
                )}

                <div className='searchResult'>
                    {isCamp ? (
                        <>
                        <CampSearchHero
                            place={place || destination}
                            checkin={searchParams.get('checkin')}
                            checkout={searchParams.get('checkout')}
                            adults={Number(searchParams.get('adults')) || 1}
                            children={Number(searchParams.get('children')) || 0}
                            image={campMeta?.heroImage}
                        />
                        <CampSearchToolbar
                            total={campMeta?.total ?? filteredData.length}
                            sortBy={sortData.sortBy === 'Low to High' ? 'low' : sortData.sortBy === 'High to Low' ? 'high' : 'relevant'}
                            onSortChange={(value) => setSortData({ sortBy: value === 'low' ? 'Low to High' : value === 'high' ? 'High to Low' : '' })}
                        />
                        </>
                    ) : (
                    <div className='alignCenter searchResultSpacing'>
                        <FilterHeader
                            title={destination || destType || activity || place}
                            subtitle='✨ Explore amazing destinations'
                            filters={[
                                {
                                    name: 'All',
                                    displayName: 'all'
                                },
                                ...(Array.isArray(locationData) ? locationData : [])
                            ]}
                            selectedFilter={selectedChipFilter}
                            onFilterChange={setSelectedChipFilter}
                            sortOptions={sortOptions}
                            selectedSort={selectedSort}
                            onSortChange={(value) => {
                                // sorted on the server (all pages) and on the loaded cards
                                setSelectedSort(value);
                                setSortData({
                                    sortBy: value === 'low' ? 'Low to High' : value === 'high' ? 'High to Low' : ''
                                });
                            }}
                            type={type}
                            searchResultRef={searchResultRef}
                        />
                    </div>
                    )}

                    <button
                        className={`filterButton mobileFilter ${isSticked ? 'sticked' : ''}`}
                        onClick={handleMobileFilter}
                        ref={filterButtonRef}
                    >
                        Filter
                    </button>

                    <div className='searchResultContentArea'>
                        {isCamp ? (
                            <CampSearchResults
                                items={filteredData}
                                checkin={searchParams.get('checkin')}
                                checkout={searchParams.get('checkout')}
                                adults={Number(searchParams.get('adults')) || 1}
                                children={Number(searchParams.get('children')) || 0}
                                pets={Number(searchParams.get('pets')) || 0}
                            />
                        ) : <TripCard imageData={filteredData} type={type} />}
                    </div>

                    {hasMore && filteredData.length > 0 && (
                        <div className='loadMoreContianer'>
                            <button onPointerDown={(e) => e.preventDefault()} onClick={handleLoadMore}>
                                Load More
                            </button>
                        </div>
                    )}

                    {filteredData?.length === 0 && !loading && <EmptyPage />}

                    {showModal && (
                        <MobileFilter
                            filterData={filterDummy?.data}
                            onFilterChange={debouncedHandleFilter}
                            handleClose={handleMobileFilter}
                            showModal={showModal}
                            prevFilters={filters}
                            type={type}
                        >
                            {isCamp ? (
                                <CampFilters
                                    sections={campSections}
                            facets={campMeta?.facets}
                                    value={campFilterValue}
                                    onChange={handleCampFilterChange}
                                />
                            ) : null}
                        </MobileFilter>
                    )}
                </div>
            </div>
        </div>
    );
}
